import axiosApiInstance from "./axiosApiInstance";
import getBaseApiUrl from "./helpers/BaseAPIURL";

const apiURL = getBaseApiUrl(window.location.hostname);

export async function GetDocuments() {
  const url = apiURL + "/api/Document/GetDocuments";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  return await axiosApiInstance
    .get(url, { headers })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
}

export async function GetDocumentsCompleted() {
  const url = apiURL + "/api/Document/GetDocumentsCompleted";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  return await axiosApiInstance
    .get(url, { headers })
    .then(function (response) {
      //console.log(response.data);
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
}

export async function GetStatusCompletedByCompany() {
  const url = apiURL + "/api/Document/GetStatusCompletedByCompany";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  return await axiosApiInstance
    .get(url, { headers })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
}

export async function GetDocumentWithPaging(
  stateFileId,
  documentTypeTemplateId,
  fileName,
  pageNumber,
  qtyRecordsPerPage,
  orderType
) {
  const url = apiURL + "/api/Document/GetDocumentWithPaging";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  const body = {
    StateFileId: stateFileId,
    DocumentTypeTemplateId: documentTypeTemplateId,
    FileName: fileName,
    PageNumber: pageNumber,
    QtyRecordsPerPage: qtyRecordsPerPage,
    OrderType: orderType,
  };

  // API validation logging
  console.log("🚀 API Request Details:");
  console.log("🌐 URL:", url);
  console.log("🔑 Headers:", {
    hasAuthHeader: !!headers.Authorization,
    authHeaderLength: headers.Authorization.length,
    authHeaderPreview: headers.Authorization.substring(0, 30) + "...",
  });
  console.log("📦 Request Body:", body);
  console.log("📝 Filename in request:", {
    fileName,
    fileNameType: typeof fileName,
    fileNameLength: fileName ? fileName.length : 0,
  });

  return await axiosApiInstance
    .post(url, body, { headers })
    .then(function (response) {
      console.log("✅ API Response:", {
        status: response.status,
        hasRecords: !!response.data.records,
        recordCount: response.data.records ? response.data.records.length : 0,
        totalRecords: response.data.qtyRecords,
      });
      return response.data;
    })
    .catch(function (error) {
      console.log("❌ API Error:", {
        status: error.response?.status,
        statusText: error.response?.statusText,
        message: error.message,
        data: error.response?.data,
      });
      return error;
    });
}

export async function GetDocumentDetail(id, result) {
  const url = apiURL + "/api/Document/GetDocumentDetail/" + id;
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  return await axiosApiInstance
    .get(url, { headers })
    .then(function (response) {
      if (typeof response.data === typeof "String") {
        return JSON.stringify(response.data);
      }
      switch (result) {
        case "1":
          return response.data.outputResult;
        case "2":
          return response.data.previousOutput;
        case "3":
          return response.data.validatedResult;
        case "4":
          return response.data.completeAWSResults;
      }
    })
    .catch(function (error) {
      return error;
    });
}
export async function GetImageDetail(id) {
  const url = apiURL + "/api/Document/GetImageDetail/" + id;
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  return await axiosApiInstance
    .get(url, { headers })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
}

export async function GetDocumentsPending() {
  const url = apiURL + "/api/Document/GetDocumentsPending";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  return await axiosApiInstance
    .get(url, { headers })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
}

export async function UploadDocument(
  fileName,
  fileType,
  fileTypeId,
  OgFileName
) {
  const url = apiURL + "/api/Document/UploadDocument";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  const body = {
    DocumentTypeId: fileTypeId,
    FileName: OgFileName,
    FilePath: fileType + "/" + fileName,
  };
  return await axiosApiInstance
    .post(url, body, { headers })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
}

export async function UpdateDocumentOutput(
  id,
  validatedResult,
  reviewCompleted
) {
  const url = apiURL + "/api/Document/UpdateDocumentOutputResult";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  var body = {};
  if (reviewCompleted > 0) {
    body = {
      Id: id,
      ValidatedResult: JSON.stringify(validatedResult),
      ReviewCompleted: 1,
    };
  } else {
    body = {
      Id: id,
      ValidatedResult: JSON.stringify(validatedResult),
    };
  }

  return await axiosApiInstance
    .post(url, body, { headers })
    .then(function (response) {
      return response.status;
    })
    .catch(function (error) {
      return error;
    });
}

export async function UpdateDocumentRestore(
  id,
  validatedResult,
  reviewCompleted
) {
  const url = apiURL + "/api/Document/UpdateDocumentOutputResult";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  var body = {};
  if (reviewCompleted > 0) {
    body = {
      Id: id,
      ValidatedResult: JSON.stringify(validatedResult),
      ReviewCompleted: 1,
    };
  } else {
    body = {
      Id: id,
      ValidatedResult: JSON.stringify(validatedResult),
    };
  }

  return await axiosApiInstance
    .post(url, body, { headers })
    .then(function (response) {
      return response.status;
    })
    .catch(function (error) {
      return error;
    });
}

export async function GetDocumentDetailInURL(id, result) {
  const url = apiURL + "/api/Document/GetDocumentDetailInURL/" + id;
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  return await axiosApiInstance
    .get(url, { headers })
    .then(function (response) {
      return GetDocumentDetailFromURL(response.data.responseURL, result);
    })
    .catch(function (error) {
      return error;
    });
}

async function GetDocumentDetailFromURL(url, result) {
  return await axiosApiInstance
    .get(url)
    .then(function (response) {
      switch (result) {
        case "0":
          return response.data.ReviewCompleted;
        case "1":
          console.log("response.data.OutputResult", response.data.OutputResult);
          return response.data.OutputResult;
        case "2":
          return response.data.PreviousOutput;
        case "3":
          return response.data.ValidatedResult;
        case "4":
          return response.data.CompleteAWSResults;
        case "5":
          return response.data.TemplateName;
        case "6":
          return response.data.Model;
        case "7":
          return response.data.ReviewCompleted;
      }
      return response.status;
    })
    .catch(function (error) {
      return error;
    });
}

export async function ExportInformation(id, ff) {
  const url = apiURL + "/api/Document/ExportInformation";
  const headers = {
    Authorization: "Bearer " + sessionStorage.token,
  };
  const body = {
    DocumentId: id,
    FileFormat: ff,
  };
  return await axiosApiInstance
    .post(url, body, { headers })
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
}
